import { muiGlyph } from "@/components/ui/mui-glyph";

// MUI's two radio glyphs, as `@mui/icons-material` draws them.
//
// Ported for the reason the arrows were: Atlas was *approximating* these with
// a CSS border circle — `size-5` plus `border-2`, and a `size-2.5` dot for the
// checked state — rather than drawing the donor's paths. The approximation is
// visibly wrong at every measurement. In a 24-unit viewBox rendered at 20px
// (scale 20/24), the donor's ring runs r=10 down to r=8, so it draws a
// **16.67px circle with a 1.67px stroke** inside a 20px box; Atlas drew a
// 20px circle with a 2px border. The checked dot is r=5 — **8.33px** — where
// Atlas drew 10px.
//
// `size-5` here is the box, not the circle: `SvgIcon`'s `fontSize: small` is
// `pxToRem(20)` against `width/height: 1em` (`SvgIcon.js:68-71`), and
// `Radio.js:187-192` clones the icon with `fontSize: size`, so a
// `size='small'` radio — which is what the catalog sidebar passes
// (`items-filter-sidebar.tsx:201,225,249`) — gets exactly that 20px box.

/** `@mui/icons-material/RadioButtonUnchecked.js` — the ring alone. */
const RADIO_UNCHECKED_PATH =
  "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8";

/**
 * `@mui/icons-material/RadioButtonChecked.js` — ring **and** dot in one path.
 *
 * One path rather than the ring plus a separate dot, because that is how MUI
 * ships it: the checked state is an icon *swap*, not an overlay
 * (`Radio.js:187-192` clones `icon` and `checkedIcon` as a pair).
 */
const RADIO_CHECKED_PATH =
  "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8";

export const MuiRadioUncheckedIcon = muiGlyph(
  "mui-radio-unchecked",
  RADIO_UNCHECKED_PATH,
  "size-5",
);
export const MuiRadioCheckedIcon = muiGlyph("mui-radio-checked", RADIO_CHECKED_PATH, "size-5");

// The same two glyphs at MUI's default `fontSize='medium'` (24px), for an
// unsized `Radio`: the Editor's locations select (#808, `LineLocations.tsx:
// 157-192`) passes none.
export const MuiRadioUncheckedMediumIcon = muiGlyph(
  "mui-radio-unchecked",
  RADIO_UNCHECKED_PATH,
  "size-6",
);
export const MuiRadioCheckedMediumIcon = muiGlyph(
  "mui-radio-checked",
  RADIO_CHECKED_PATH,
  "size-6",
);
